<template>
    <div class="marginCon">
        <Card>
            <div class="search-div flexC">
                 <div class="search-div-item flexC">
                   <div class="labelText">{{$t("feedBack.searchEmail")}}</div>
                   <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.userEmail" ></Input>
                </div>

                 <div class="search-div-item flexC">
                   <div class="labelText">{{$t("feedBack.selectType")}}</div>
                    <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.statusForManager" >
                        <Option v-for="(item, index) in searchObjArr.type" :value="item.id" :key="index">{{item['val']}}</Option>
                    </Select>
                </div>

                 <div class="search-div-item">
                   <Button type="info" @click="searchItem"  icon="ios-search" style="margin-top:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
                </div>
            </div>
          
              <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange"  :loading='loading'></Table>
              <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
              
    
              <!-- 详情 -->
              <detailModelBox :showModel.sync="detailBox.showModel" :fn="detailBox.callbackFn"  :editFormData="detailBox.editFormData"></detailModelBox>
    
            
        </Card>
    </div>
</template>
<script>
import common from '@/common/common.js';
import detailModelBox from './component/detailModel.vue';
import moment from 'moment';
import { mapState } from 'vuex'
    export default {
        name: "merchantAdmin",
        components: {
            detailModelBox
        },
        data(){
            return{
                selectChangeData: [],
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                detailBox:{//规格弹框组-详情
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
               
                searchObj:{
                    statusForManager:"",
                    userEmail:""
                },
             
            }
        },
        computed:{
          ...mapState(['local','selectId']),
           searchObjArr(){
                return {
                    type:[
                       {id: 1,val:this.$t('selectList.MessageStatus.New')},
                       {id: 2,val:this.$t('selectList.MessageStatus.Read')},
                       {id: 3,val:this.$t('selectList.MessageStatus.Reply')},
                    ],
                }
            },
            titleName(){
                return [
                    {
                        title:this.$t('feedBack.titleName.id'),
                        'title-zh-CN':'序列号',
                        'title-en-US':'Serial number',
                        key: 'id',
                        sortable: true,
                        minWidth: 180
                    },
                    {
                        title:this.$t('feedBack.titleName.latestMessageTime'),
                        'title-zh-CN':'接收时间',
                        'title-en-US':'Receiver time',
                        key: 'latestMessageTime',
                        minWidth: 180,
                        
                    },
                    {
                        title:this.$t('feedBack.titleName.userEmail'),
                        'title-zh-CN':'用户邮箱',
                        'title-en-US':'userEmail',
                        key: 'userEmail',
                        sortable: true,
                        minWidth: 260
                    },
                    {
                        title:this.$t('feedBack.titleName.phoneNumber'),
                        'title-zh-CN':'用户手机号',
                        'title-en-US':'phoneNumber',
                        key: 'phoneNumber',
                        minWidth: 150
                    },
                    {
                        title:this.$t('feedBack.titleName.statusForManager'),
                        'title-zh-CN':'消息状态',
                        'title-en-US':'Status',
                        key: 'statusForManager',
                        minWidth: 180,
                        render:(h, params)=>{
                             let flag = params.row.statusForManager
                             let obj = {'1':this.$t('selectList.MessageStatus.New'),'2':this.$t('selectList.MessageStatus.Read'),'3':this.$t('selectList.MessageStatus.Reply')}
                             let colorObj= {'1':'#ed4014','2':'#5a516e','3':'#5a516e'}
                             let stext = obj.hasOwnProperty(flag)?obj[flag] :flag
                             let style = {
                                 color:colorObj[flag]
                             }
                             return h('div',{style},stext || '')
                        }
                    },
                    {
                        title:this.$t('feedBack.titleName.latestMessage'),
                        'title-zh-CN':'消息',
                        'title-en-US':'Message',
                        key: 'latestMessage',
                        minWidth: 260
                    },
                    {
			    	    title:this.$t('feedBack.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
			    	    minWidth:120,
                        key: "id",
                        // fixed:'right',
			    	    render: (h, params) => {
                            let that = this
                            return [
                                h('div',
                                   { 
                                    style:{
                                        display: "flex",
                                        justifyContent:'center'
                                        }
                                    },[
                                        h('Button', {
			    	                        props: {
                                                type: "primary",
                                                size: 'small'
                                            },
                                            style:{
                                                marginRight:"10px"
                                            },
			    	                        on: {
			    	                            click: () => { this.showDetail(params.row) }
			    	                        }
			    	                    },that.$t("detail"))
                                    ]
                                )
                            ]
			    	    }
			    	},
                ]
            },
        },
        created() {
            this.getData();
        },
        methods: {
            searchItem(){ //搜索
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 10
                this.getData()
            },
            getData() {//获取数据
                let getData = {
                    params: {
                        page: this.page.current,
                        limit: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order,
                        dealerId:this.selectId
                    }
                }
               
                Object.assign(getData.params,this.searchObj)

                this.axios.post(this.config.urlArray.messageGroupList, getData.params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data.feedBackGroupList
                        this.tableList.tableData  = resData
                        this.page.total = result.data.data.count
                        this.loading = false
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            
            showDetail(row){
                this.detailBox.showModel = true
                this.detailBox.editFormData = row
                this.detailBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.detailBox.showModel = false;
                    this.getData();
                }
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                this.selectChangeData = res
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData();
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>

 <style scoped lang="less">
 .search-div{
     flex-wrap: wrap;
     background-color: #fff;
     padding: 30px 20px ;
     background: #FFFFFF;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
         .labelText{
             height: 54px;
             line-height: 54px;
             margin-right: 4px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
          height:44px;
         line-height: 44px;
     }
 }
 </style>